import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Toolbar/toolbar';
import { GenerateId } from '../../helpers/GenerateId/GenerateId';
import { css } from '@patternfly/react-styles';
import { ToolbarContext } from './ToolbarUtils';
import { ToolbarChipGroupContent } from './ToolbarChipGroupContent';
export var Toolbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Toolbar, _React$Component);

  function Toolbar() {
    var _this;

    _classCallCheck(this, Toolbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toolbar).apply(this, arguments));
    _this.chipGroupContentRef = React.createRef();
    _this.staticFilterInfo = {};
    _this.state = {
      isManagedToggleExpanded: false,
      filterInfo: {}
    };

    _this.isToggleManaged = function () {
      return !(_this.props.isExpanded || !!_this.props.toggleIsExpanded);
    };

    _this.toggleIsExpanded = function () {
      _this.setState(function (prevState) {
        return {
          isManagedToggleExpanded: !prevState.isManagedToggleExpanded
        };
      });
    };

    _this.closeExpandableContent = function () {
      _this.setState(function () {
        return {
          isManagedToggleExpanded: false
        };
      });
    };

    _this.updateNumberFilters = function (categoryName, numberOfFilters) {
      var filterInfoToUpdate = Object.assign({}, _this.staticFilterInfo);

      if (!filterInfoToUpdate.hasOwnProperty(categoryName) || filterInfoToUpdate[categoryName] !== numberOfFilters) {
        filterInfoToUpdate[categoryName] = numberOfFilters;
        _this.staticFilterInfo = filterInfoToUpdate;

        _this.setState({
          filterInfo: filterInfoToUpdate
        });
      }
    };

    _this.getNumberOfFilters = function () {
      return Object.values(_this.state.filterInfo).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    };

    _this.renderToolbar = function (randomId) {
      var _a = _this.props,
          clearAllFilters = _a.clearAllFilters,
          clearFiltersButtonText = _a.clearFiltersButtonText,
          collapseListedFiltersBreakpoint = _a.collapseListedFiltersBreakpoint,
          isExpandedProp = _a.isExpanded,
          toggleIsExpanded = _a.toggleIsExpanded,
          className = _a.className,
          children = _a.children,
          props = __rest(_a, ["clearAllFilters", "clearFiltersButtonText", "collapseListedFiltersBreakpoint", "isExpanded", "toggleIsExpanded", "className", "children"]);

      var isManagedToggleExpanded = _this.state.isManagedToggleExpanded;

      var isToggleManaged = _this.isToggleManaged();

      var isExpanded = isToggleManaged ? isManagedToggleExpanded : isExpandedProp;

      var numberOfFilters = _this.getNumberOfFilters();

      var showClearFiltersButton = numberOfFilters > 0;
      return React.createElement("div", Object.assign({
        className: css(styles.toolbar, className),
        id: randomId
      }, props), React.createElement(ToolbarContext.Provider, {
        value: {
          isExpanded: isExpanded,
          toggleIsExpanded: isToggleManaged ? _this.toggleIsExpanded : toggleIsExpanded,
          chipGroupContentRef: _this.chipGroupContentRef,
          updateNumberFilters: _this.updateNumberFilters,
          numberOfFilters: numberOfFilters,
          clearAllFilters: clearAllFilters,
          clearFiltersButtonText: clearFiltersButtonText,
          showClearFiltersButton: showClearFiltersButton,
          toolbarId: randomId
        }
      }, children, React.createElement(ToolbarChipGroupContent, {
        isExpanded: isExpanded,
        chipGroupContentRef: _this.chipGroupContentRef,
        clearAllFilters: clearAllFilters,
        showClearFiltersButton: showClearFiltersButton,
        clearFiltersButtonText: clearFiltersButtonText,
        numberOfFilters: numberOfFilters,
        collapseListedFiltersBreakpoint: collapseListedFiltersBreakpoint
      })));
    };

    return _this;
  }

  _createClass(Toolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isToggleManaged()) {
        window.addEventListener('resize', this.closeExpandableContent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.isToggleManaged()) {
        window.removeEventListener('resize', this.closeExpandableContent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.id ? this.renderToolbar(this.props.id) : React.createElement(GenerateId, null, function (randomId) {
        return _this2.renderToolbar(randomId);
      });
    }
  }]);

  return Toolbar;
}(React.Component);